// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '케이에스제약',
  targetSheetName: '케이에스제약 전품목 수수료율표 (신)',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험수가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '품목군',
    '약가유지여부',
    '제품명',
    '보험코드',
    '성분/함량',
    '보험수가',
    '약가인하(15%)',
    '수수료',
    '비고',
  ],
});
